<template>
  <div class="column">
    <div :class="labelClasses" class="r-text-body-small">{{ label }}</div>
    <r-input
      ref="input"
      :type="type"
      :value="value"
      :label="label"
      :tabindex="tabindex"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :error="error"
      :error-message="errorMessage"
      :validations="validations"
      :input-style="mergedInputStyle"
      :bg-color="bgColor"
      :autofocus="autofocus"
      :maxlength="maxlength"
      :debounce="debounce"
      color="riseup-blue"
      v-on="$listeners"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput" />
  </div>
</template>

<script>
import RInput from '@/components/base/RInput';
import WithValidation from '@/mixins/WithValidation';
import _ from 'lodash';

export default {
  name: 'DefaultTextInput',
  components: { RInput },
  mixins: [WithValidation],
  data() {
    return {
      focused: false,
    };
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    tabindex: Number,
    type: {
      type: String,
      default: 'text',
    },
    validations: [String, Object, Function],
    autofocus: Boolean,
    autocomplete: String,
    maxlength: Number,
    debounce: Number,
    inputStyle: [String, Object],
    serverErrorMessage: String,
  },
  computed: {
    labelClasses() {
      if (this.focused) {
        return ['r-text-bold', `text-${this.color}`];
      }
      return [`text-${this.color}`];
    },
    color() {
      if (this.error) {
        return 'riseup-danger-red';
      }
      return this.focused ? 'riseup-blue' : 'riseup-black';
    },
    bgColor() {
      if (this.focused) {
        return 'riseup-white';
      }
      return null;
    },
    mergedInputStyle() {
      return _.merge({ padding: '5px' }, this.inputStyle);
    },
    error() {
      return !!this.errorMessage;
    },
    errorMessage() {
      return this.validationErrorMessage || this.serverErrorMessage;
    },
  },
  methods: {
    onBlur() {
      this.validate();
      this.focused = false;
    },
    onFocus() {
      this.focused = true;
    },
    onInput(value) {
      this.reset();
      this.$emit('input', value);
    },
    focus() {
      this.$refs.input.focus();
    },
  },

};
</script>
